// extracted by mini-css-extract-plugin
module.exports = {"saveFilterBtn":"SaveFilterBlock_saveFilterBtn__1_MDL"};